// import Vue from 'vue'
import * as Ably from 'ably'
import store from '../store'
import parser from './parser'
import chatMessage from '../api/chat_message'
import localforage from 'localforage'

export default {
  channels: [],
  realtime: null,

  init (doctorId, token) {
    if (window.realtime === undefined) {
      if (window.location.host === 'consultations.ekincare.com') {
        // Production Key
        window.realtime = new Ably.Realtime({ key: token, clientId: doctorId })
      } else {
        // Staging or local
        window.realtime = new Ably.Realtime({ key: token, clientId: doctorId })
      }
    }
    window.realtime.connection.on('connected', this.connected)
    window.realtime.connection.on('disconnected', this.disconnected)
    window.realtime.connection.on('suspended', this.suspended)
    window.realtime.connection.on('failed', this.failed)

    window.realtime.connection.on('closing', this.closing)
    window.realtime.connection.on('closed', this.closed)
    window.realtime.connection.on('connecting', this.connecting)
    window.realtime.connection.on('initialized', this.initialized)
  },

  close () {
    if (window.realtime !== undefined) {
      window.realtime.connection.close()
      delete window.realtime
    }
    this.channels = []
  },

  connected () {
    store.dispatch('configuration/ablyConnected')
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'connected', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  disconnected () {
    store.dispatch('configuration/ablyDisconnected')
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'disconnected', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  suspended () {
    store.dispatch('configuration/ablySuspended')
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'suspended', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  failed () {
    store.dispatch('configuration/ablyFailed')
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'failed', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  closed (channelId, payload) {
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'closed', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  closing (channelId, payload) {
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'closing', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  connecting (channelId, payload) {
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'connecting', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  initialized (channelId, payload) {
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push({type: 'ably', event: 'initialized', created_at: new Date().toString()})
        localforage.setItem('audits', data)
      }
    })
  },

  publishMessage (channelId, payload) {
    let channel = this.channels.find((ele) => {
      return ele.name === channelId
    })
    channel.publish('update', JSON.stringify(payload), function (err) {
      if (err) {
        console.log('Unable to publish message; err = ' + err.message)
        store.dispatch('message/sentMsgStatus', { message: payload, status: false, channelId: channelId })
      } else {
        store.dispatch('message/sentMsgStatus', { message: payload, status: true, channelId: channelId })
      }
    })
  },

  receiveMessage (channelId, payload) {
    let message = Object.assign({}, payload)
    message.channelId = channelId
    parser.parseMessage(channelId, payload)

    let payloadData = JSON.parse(payload.data)
    localforage.getItem('audits', function (err, data) {
      if (err === null && data !== null && data !== undefined) {
        data.push(
          {
            type: 'message',
            event: 'receive_message',
            channel_name: channelId,
            consultation_request_id: payloadData.consultation_request_id,
            customer_id: payloadData.customer_id,
            intent_name: payloadData.intentName,
            unique_id: payloadData.uniqueId,
            user: payloadData.user,
            created_at: new Date().toString()
          }
        )
        localforage.setItem('audits', data)
      }
    })
    if (JSON.parse(message.data).intentName === 'file_customer') {
      let channelId = message.channelId
      let customerId = message.channelId
      store.dispatch('consultation/fetchCustomerProfile', {customerId: customerId, channelId: channelId})
    }
    chatMessage.storeMessage(message).then(response => {
      if (response.status === 200) {
        console.log('stored')
      }
    }).catch(e => console.log(e))
  },

  // updatePresenceEvents (channelId, event, isTyping = false) {
  updatePresenceEvents (channelId, event, data = {}) {
    if (window.realtime) {
      let channel = window.realtime.channels.get(channelId)
      if (event === 'enter') {
        channel.presence.enter('', function (err) {
          if (err) {
            console.log('Error entering presence')
            localforage.getItem('audits', function (err, data) {
              if (err === null && data !== null && data !== undefined) {
                data.push({type: 'error', event: 'enter', channel_name: channelId, error: err, created_at: new Date().toString()})
                localforage.setItem('audits', data)
              }
            })
          }

          store.dispatch('consultation/ablyEnabled', { channelId: channelId, status: true })

          localforage.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({type: 'presence', event: 'enter', channel_name: channelId, created_at: new Date().toString()})
              localforage.setItem('audits', data)
            }
          })
        })
      } else if (event === 'leave') {
        channel.unsubscribe()
        channel.presence.leave('', function (err) {
          if (err) {
            console.log('Error leaving presence')
            localforage.getItem('audits', function (err, data) {
              if (err === null && data !== null && data !== undefined) {
                data.push({type: 'error', event: 'leave', channel_name: channelId, created_at: new Date().toString()})
                localforage.setItem('audits', data)
              }
            })
          }
          console.log('doctor left ' + channelId)

          store.dispatch('consultation/ablyEnabled', { channelId: channelId, status: false })

          localforage.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({type: 'presence', event: 'leave', channel_name: channelId, created_at: new Date().toString().toString()})
              localforage.setItem('audits', data)
            }
          })
        })
      } else if (event === 'update') {
        let msg = parser.buildPresenceUpdate(data)
        channel.presence.update(JSON.stringify(msg))
      }
    } else {
      store.dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Chat error.Please Refresh'}, { root: true })
    }
  },

  subscribePresenceEvents (channel, event) {
    let that = this
    channel.presence.subscribe(event, function (member) {
      if (event === 'enter') {
        if (channel !== 'doctor_channel' && member.clientId !== store.state.configuration.doctorId) {
          that.updatePatientStatus(channel.name)
        }
      } else if (event === 'leave' && member.clientId !== store.state.configuration.doctorId) {
        if (channel !== 'doctor_channel') {
          that.updatePatientStatus(channel.name)
        }
      } else if (event === 'update' && member.clientId !== store.state.configuration.doctorId) {
        if (member.data[0] === '{') {
          let data = JSON.parse(member.data)
          if (data.user && data.user.type === 'customer') {
            that.updateMessagesStatus(channel.name, data)
          }
        }
      }
    })
  },

  getConsultation (channelId) {
    let consult = store.state.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    return consult
  },

  updatePatientStatus (channelId) {
    if (window.realtime) {
      let consult = this.getConsultation(channelId)
      let channel = window.realtime.channels.get(channelId)
      let ids = []
      channel.presence.get(function (err, members) {
        if (err) {
          console.log('Error fetching channel members')
          return []
        }
        for (let i = 0; i < members.length; i++) {
          ids.push(members[i].clientId)
        }
        if (ids.includes(consult.customerId) || ids.includes(consult.guardian_ek_id)) {
          store.dispatch('consultation/updateIsOnline', { channelId: channelId, status: true })
          localforage.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({type: 'patient_presence', event: 'subscribe', online: true, customer_id: consult.customerId, channel_name: channelId, created_at: new Date().toString()})
              localforage.setItem('audits', data)
            }
          })
        } else {
          store.dispatch('consultation/updateIsOnline', { channelId: channelId, status: false })
          localforage.getItem('audits', function (err, data) {
            if (err === null && data !== null && data !== undefined) {
              data.push({type: 'patient_presence', event: 'subscribe', online: false, customer_id: consult.customerId, channel_name: channelId, created_at: new Date().toString()})
              localforage.setItem('audits', data)
            }
          })
        }
      })
    } else {
      store.dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Chat error.Please Refresh'}, { root: true })
    }
  },

  updateMessagesStatus (channelId, data) {
    if (window.realtime) {
      let consult = this.getConsultation(channelId)
      let channel = window.realtime.channels.get(channelId)
      let ids = []
      channel.presence.get(function (err, members) {
        if (err) {
          console.log('Error fetching channel members')
          return []
        }
        for (let i = 0; i < members.length; i++) {
          ids.push(members[i].clientId)
        }
        if (ids.includes(consult.customerId) || ids.includes(consult.guardian_ek_id)) {
          store.dispatch('consultation/receiveCustomerTyping', { channelId: channelId, isTyping: data.typing })
          if (data.deliveredMessage !== undefined && data.deliveredMessage !== '') {
            store.dispatch('message/receiveCustomerLastDelivered', { channelId: channelId, deliveredMessage: data.deliveredMessage })
          }
          if (data.lastReadMessage !== undefined && data.lastReadMessage !== '') {
            store.dispatch('message/receiveCustomerLastRead', { channelId: channelId, lastReadMessage: data.lastReadMessage })
          }
        }
      })
    } else {
      store.dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Chat error.Please Refresh'}, { root: true })
    }
  },

  subscribeToChannel (channelId) {
    if (window.realtime) {
      let channel = window.realtime.channels.get(channelId)
      let newFunction = this.receiveMessage.bind('', channelId)
      channel.subscribe(newFunction)
      this.updatePresenceEvents(channelId, 'enter')
      this.subscribePresenceEvents(channel, 'enter')
      this.subscribePresenceEvents(channel, 'leave')
      this.subscribePresenceEvents(channel, 'update')
      this.channels.push(channel)
    } else {
      alert('There is some error when connecting to chat service, please refresh and try.')
    }
  },

  // Subscribes to channels
  subscribeToChannels (customerIds) {
    customerIds.forEach(function (channelId) {
      this.subscribeToChannel(channelId)
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/ably.js